import { Section } from 'utils/types/contentfulTypes';

import { PromotionBannerV2Props } from './PromotionBannerV2';

export const parsePromotionBannerV2Data = (
  contentfulSection: Section,
): PromotionBannerV2Props | null => {
  const { body, images } = contentfulSection;

  const { theme, ctas } = contentfulSection.metadata || {};

  const { backgroundColor, textColor, primaryColor } = theme || {};
  const desktopBackgroundImage = images && images[0].desktopImage;
  const desktopBackgroundImageAltText = images && images[0].desktopImageAltText;
  const mobileBackgroundImage = images && images[0].mobileImage;
  const mobileBackgroundImageAltText = images && images[0].mobileImageAltText;

  const PromotionBannerV2Props: PromotionBannerV2Props = {
    bgColor: backgroundColor,
    headingColor: primaryColor,
    textColor: textColor,
    description: body,
    desktopBackgroundImage: desktopBackgroundImage,
    desktopBackgroundImageAltText: desktopBackgroundImageAltText,
    mobileBackgroundImage: mobileBackgroundImage,
    mobileBackgroundImageAltText: mobileBackgroundImageAltText,
    cta: ctas?.[0],
  };

  return PromotionBannerV2Props;
};
